/* eslint-disable react-native/no-unused-styles -- porting from old code. */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View, type StyleType} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import {GuideColors} from "./guide-colors.ts";

// em values
const DOT_SIZE = {
    small: 0.2,
    medium: 0.25,
    large: 0.3,
    xlarge: 0.5,
} as const;

interface Props {
    numDots?: number;
    color?: string;
    size?: keyof typeof DOT_SIZE;
    style?: StyleType;
}

const LoadingDots = (props: Props): React.ReactElement => {
    const {
        color = GuideColors.darkPurple,
        numDots = 3,
        size = "medium",
        style,
    } = props;
    const dots: Array<JSX.Element> = [];
    const styles = getStyles(DOT_SIZE[size], color);
    for (let i = 0; i < numDots; i++) {
        dots.push(
            <View
                key={`typing-indicator-dot-${i}`}
                style={[
                    styles.dot,
                    styles.bounce,
                    {animationDelay: `${i * 100}ms`},
                ]}
            />,
        );
    }
    return (
        <View style={[styles.dots, style]} testId="loading-dots">
            {dots}
        </View>
    );
};

const BOUNCE_KEY_FRAMES = {
    "0%, 100%": {
        transform: "translateY(50%)",
        animationTimingFunction: "cubic-bezier(0.8,0,1,1)",
    },
    "50%": {
        transform: "none",
        animationTimingFunction: "cubic-bezier(0,0,0.2,1)",
    },
} as const;

const getStyles = (size: number, color: string) =>
    StyleSheet.create({
        bounce: {
            animationDuration: "700ms",
            animationIterationCount: "infinite",
            // NOTE(kevinb): `Array` is not assignable to `string | number`
            animationName: [BOUNCE_KEY_FRAMES] as TSFixMe,
        },

        dots: {
            flexDirection: "row",
            justifyContent: "center",
            gap: `${size * 0.8}em`,
            top: `${-size}em`,
            paddingBlockEnd: spacing.xxxxSmall_2,
            height: "fit-content",
            width: "fit-content",
            alignSelf: "flex-end",
        },

        dot: {
            backgroundColor: color,
            opacity: 0.75,
            borderRadius: "100%",
            height: `${size}em`,
            width: `${size}em`,
            alignSelf: "flex-end",
        },
    });

export {LoadingDots};
